import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {SkillsRequests} from "../../services/skills-requests.service";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class SkillsMultiSelectListCtrl implements IController {
  selectedIds: any;
  excludeIds: any;
  options?: any;
  optionIds?: any;
  ngPlaceholder: any;
  onChange: Function;

  public loading: boolean;
  private skills: any;
  private queryString: any;
  private selectedKeys: any;
  private excludeKeys: any;
  public isSelectAll: boolean;

  /* @ngInject */
  constructor(private skillsRequests: SkillsRequests, private $log: ILogService, private commonsService: CommonsService) {
  }

  $onInit() {

    this.loading = true;

    if (!this.selectedIds) {
      this.selectedIds = []
    }

    if (!this.options) {
      this.skillsRequests.getAll(this.optionIds)
        .then((skills) => {
          this.skills = skills;
        })
        .finally(() => {
          this.loading = false;
        })
    } else {
      this.skills = angular.copy(this.options);
      this.loading = false;
    }

  }

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }
    if (changes.excludeIds) {
      this.excludeKeys = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludeKeys[id] = true;
      })
    }
  }

  onToggle(skillId, isSelected) {
    this.onChange({
      skillsIds: isSelected ? _.concat(this.selectedIds || [], [skillId]) :
        _.filter(this.selectedIds, (id) => {
          return id !== skillId;
        })
    });
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onChange({skillsIds: []});
    } else {
      this.onChange({skillsIds: this.skills?.map((skill) => skill.id)});
    }
  }

  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.skills?.map((skill) => skill.id), this.selectedIds);
    return this.isSelectAll;
  }


}

angular
  .module('bringoz.admin.skills')
  .component('skillsMultiSelectList', {
    bindings: {
      selectedIds: '<',
      excludeIds: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./skills-multi-select-list.html').default,
    controller: SkillsMultiSelectListCtrl
  });
